import { InfoOutlined } from '@mui/icons-material';
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Modal, Typography } from "@mui/material";
import { IconCopy } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import defaultImage from "../../../assets/images/default.jpg";
import { usePermission } from '../../../hooks/usePermission';
import { permissionError, warningAccept } from '../../../util/Alert';
import Button from '../../extra/Button';
import DateRangeSelect from '../../extra/DateRangeSelect';
import Iconb from '../../extra/Iconb';
import ImagePreviewModal from '../../extra/ImagePreviewModal';
import Input from "../../extra/Input";
import Pagination from '../../extra/Pagination';
import Table from '../../extra/Table';
import { acceptWithdrawalRequest, declineWithdrawalRequest, getWithdrawalRequest } from '../../store/redeem/redeem.action';
import { getSetting } from '../../store/setting/setting.action';

const AdminWithdrawal = (props) => {

    const { can } = usePermission();
    const canEdit = can("Seller Withdrawal", "Edit");
    const canDelete = can("Seller Withdrawal", "Delete");

    const hasPermission = useSelector((state) => state.admin.admin?.flag);
    const dispatch = useDispatch();
    const [size, setSize] = useState(10);
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sDate, setsDate] = useState("All");
    const [eDate, seteDate] = useState("All");
    const [status, setStatus] = useState("1");

    // State variables
    const [reasonData, setReasonData] = useState("");
    const [openReason, setOpenReason] = useState(false);
    const [declinedId, setDeclinedId] = useState(null);
    const [openPayment, setOpenPayment] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const [showImageModal, setShowImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");

    const { defaultCurrency } = useSelector((state) => state.currency);

    const [error, setError] = useState({
        reason: "",
    });

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "95%",
        maxWidth: 600,
        backgroundColor: "background.paper",
        borderRadius: "13px",
        border: "1px solid #C9C9C9",
        boxShadow: "24px",
        padding: "19px",
        maxHeight: "95vh",
        overflowY: "auto",
    };


    const { sellerWithdrawal, total, loadingg } = useSelector((state) => state.redeem);
    const { setting } = useSelector((state) => state.setting);

    useEffect(() => {
        dispatch(getSetting());
        dispatch(getWithdrawalRequest(currentPage, rowsPerPage, sDate, eDate, status));
    }, [currentPage, rowsPerPage, sDate, eDate, status])


    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setLoading(false);
    //     }, 1500); // Adjust the delay time as needed

    //     return () => clearTimeout(timer);
    // }, []);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event), 10);
        setSize(parseInt(event), 10);
        setCurrentPage(1);
    };

    const handleDateApply = (dayStart, dayEnd) => {
        setsDate(dayStart);
        seteDate(dayEnd);
        setCurrentPage(1);
    };

    const handleDateClear = () => {
        setsDate("All");
        seteDate("All");
        setCurrentPage(1);
    };

    useEffect(() => {
        setData(sellerWithdrawal);
    }, [sellerWithdrawal])

    const handleClick = (requestId, personId) => {
        warningAccept()
            .then((isDeleted) => {
                if (!isDeleted) return;
                if (!hasPermission) return permissionError();
                const payload = {
                    requestId,
                    personId
                };
                dispatch(acceptWithdrawalRequest(payload));
            })
            .catch((err) => console.log(err));
    };



    // Decline handler
    const handleDecline = (requestId, sellerId) => {
        if (!hasPermission) return permissionError();

        setOpenReason(true);
        setDeclinedId({ requestId, sellerId });
    };

    // Modal handlers
    const handleCloseReason = () => {
        setOpenReason(false);
        setReasonData("");
        setError({ reason: "" });
    };

    const handleSubmit = () => {
        if (!reasonData) {
            setError({ reason: "Reason is required" });
            return;
        }

        const payload = {
            requestId: declinedId.requestId,
            personId: declinedId.sellerId,
            reason: reasonData,
        };

        dispatch(declineWithdrawalRequest(payload));
        handleCloseReason();
    };

    const copyToClipboard = (Text) => {
        navigator.clipboard.writeText(Text);
        toast.success("Unique ID copied to clipboard");
    };

    const handleOpenPayment = (details) => {
        try {
            const parsed = typeof details === "string" ? JSON.parse(details) : details;
            setPaymentData(parsed);
            setOpenPayment(true);
        } catch {
            setPaymentData({ raw: details });
            setOpenPayment(true);
        }
    };

    const handleClosePayment = () => {
        setOpenPayment(false);
        setPaymentData(null);
    };


    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) => (
                <span className="text-white">
                    {(currentPage - 1) * rowsPerPage + index + 1}
                </span>
            ),
        },

        {
            Header: "Unique Id",
            body: "uniqueId",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">
                    {row.uniqueId ? row.uniqueId : "-"}  <IconCopy
                        size={16}
                        className="ms-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => copyToClipboard(row?.uniqueId)}
                    /></span>
            ),
        },

        {
            Header: "Seller",
            body: "seller",
            Cell: ({ row }) => {
                const seller = row?.sellerId;
                const imageUrl = seller?.image || defaultImage;

                return (
                    <div style={{ display: "flex", alignItems: "center", gap: "20px", justifyContent: "center" }}>
                        <img
                            src={imageUrl}
                            height={45}
                            width={45}
                            alt="seller"
                            style={{ borderRadius: "10px", cursor: "pointer" , objectFit: "cover" }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/defaultImage.png';
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (!seller?.image) return;
                                setSelectedImage(imageUrl);
                                setShowImageModal(true);
                            }}
                            onLoad={() => console.log("Image loaded successfully")}
                        />

                        {/* Seller Name */}
                        <div className='d-flex flex-column text-start'>
                            <span className="mb-0 text-white">
                                {seller?.firstName} {seller?.lastName}
                            </span>
                            <span className="mb-0 text-white">
                                {seller.uniqueId ? seller.uniqueId : "-"}  <IconCopy
                                    size={16}
                                    className="ms-1"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => copyToClipboard(seller?.uniqueId)}
                                />
                            </span>
                        </div>
                    </div>
                );
            },
        },


        {
            Header: "Business Name",
            body: "businessName",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.sellerId?.businessName}</span>
            ),
        },

        {
            Header: "Business Tag",
            body: "businessTag",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.sellerId?.businessTag}</span>
            ),
        },




        {
            Header: `Amount (${setting?.currency?.symbol})`,
            body: "amount",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{setting?.currency?.symbol} {row?.amount}</span>
            ),
        },

        {
            Header: "Payment Gateway",
            body: "paymentGateway",
            Cell: ({ row }) => (
                <span className="mb-0 text-white">{row?.paymentGateway}</span>
            ),
        },

        {
            Header:
                status === "1"
                    ? "Created Date"
                    : status === "2"
                        ? "Accepted Date"
                        : status === "3"
                            ? "Declined Date"
                            : "Date",
            body: status === "1" ? "createdAt" : "updatedAt", // Optional, for sorting/filter
            Cell: ({ row }) => (
                <span className="text-white">
                    {status === "1"
                        ? dayjs(row.createdAt).format("DD MMM YYYY")
                        : status === "2"
                            ? dayjs(row.updatedAt).format("DD MMM YYYY")
                            : status === "3"
                                ? dayjs(row.updatedAt).format("DD MMM YYYY")
                                : dayjs(row.createdAt).format("DD MMM YYYY")}
                </span>
            ),
        },

     


        ...(status === "3" ? [{
            Header: "Reason",
            body: "reason",
            Cell: ({ row }) => (
                <span className="mb-0 text-white" title={row?.reason}>
                    {row?.reason ? (
                        row?.reason.length > 20 ?
                            row?.reason.substring(0, 20) + "..." :
                            row?.reason
                    ) : "N/A"}
                </span>
            ),
        }] : []),
        
           {
            Header: "payment Details",
            body: "paymentDetails",
            Cell: ({ row }) => (
                <InfoOutlined
                    size={20}
                    style={{
                        cursor: "pointer",
                        color: "#555",
                        transition: "0.2s"
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#b93160")}
                    onMouseLeave={(e) => (e.target.style.color = "#555")}
                    onClick={() => handleOpenPayment(row)}
                />
            )

        },


        ...(status === "1" && (canEdit || canDelete) ? [{
            Header: "Action",
            body: "",
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center align-items-center gap-2">
                    {canEdit && (
                        <Iconb
                            newClass="themeFont boxCenter acptbtn userBtn fs-5"
                            btnIcon={<CheckCircleIcon sx={{ color: "green" }} />}
                            style={{
                                borderRadius: "5px",
                                width: "40px",
                                cursor: "pointer",
                            }}
                            isImage={true}
                            onClick={() => handleClick(row?._id, row?.sellerId?._id)}
                            title="Accept Request"
                        />
                    )}

                    {canDelete && (

                        <Iconb
                            newClass="themeFont boxCenter killbtn userBtn fs-5"
                            btnIcon={<CancelIcon sx={{ color: "red" }} />}
                            style={{
                                borderRadius: "5px",
                                width: "40px",
                                cursor: "pointer",
                            }}
                            isImage={true}
                            onClick={() => handleDecline(row?._id, row?.sellerId?._id)}
                            title="Decline Request"
                        />
                    )}
                </div>
            ),
        }] : [])
    ];




    return (
        <div className="mainSellerTable">
            <Modal
                open={openPayment}
                onClose={handleClosePayment}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="model-header">
                        <p className="m-0">Payment Details Info</p>
                    </div>

                    <div className="model-body">
                        <form>
                            <div className="row sound-add-box" style={{ overflowX: "hidden" }}>
                                <div className="col-12">

                                    {/* Gateway */}
                                    <Input
                                        type="text"
                                        label="Payment Gateway"
                                        value={paymentData?.paymentGateway || "-"}
                                        readOnly
                                    />

                                    {/* Details */}
                                    {paymentData?.paymentDetails?.map((item, index) => {
                                        const [label, ...rest] = item.split(":");
                                        const value = rest.join(":");

                                        return (
                                            <div className="col-12 mt-2 text-about" key={index}>
                                                <Input
                                                    type="text"
                                                    label={label}
                                                    value={value || "-"}
                                                    readOnly
                                                />
                                            </div>
                                        );
                                    })}

                                </div>

                            </div>
                        </form>
                    </div>

                    <div className="model-footer">
                        <div className="p-3 d-flex justify-content-end">
                            <Button
                                btnColor="myCustomButton"
                                style={{ borderRadius: "5px", width: "80px" }}
                                onClick={handleClosePayment}
                                btnName={"Close"}
                            />
                        </div>
                    </div>
                </Box>
            </Modal>

            <div className="sellerTable">
                <div className="col-12 headname">Seller Withdrawal</div>
                <div className="sellerMain">
                    <div className="tableMain mt-2">
                        <div className="sellerHeader primeHeader">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-start">
                                    <div
                                        className="themediv"
                                        style={{
                                            display: "flex",
                                            borderRadius: "5px ",

                                            backgroundColor: "#fff",
                                            padding: "0px",
                                            width: "fit-content",
                                            margin: "10px 0px 0px 0px"
                                        }}
                                    >
                                        <Button
                                            newClass="themeFont"
                                            btnName="Pending"
                                            style={{
                                                borderRadius: "5px 0px 0px 5px",
                                                backgroundColor: status === "Create" ? "#f7dada" : "transparent",
                                                color: status === "1" || status === "All" ? "#b93160" : "#2f2b3db3",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                opacity: 1,
                                                padding: "10px 20px",
                                                border: "0.5px solid #D8D7DC",
                                                transition: "all 0.2s ease",
                                            }}
                                            onClick={() => setStatus("1")}
                                        />
                                        <Button
                                            newClass="themeFont"
                                            btnName="Accepted"
                                            style={{
                                                borderRadius: "0px",
                                                backgroundColor: status === "Update" ? "#f7dada" : "transparent",
                                                color: status === "2" ? "#b93160" : "#2f2b3db3",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                opacity: 1,
                                                padding: "10px 20px",
                                                border: "0.5px solid #D8D7DC",
                                                transition: "all 0.3s ease",
                                            }}
                                            onClick={() => setStatus("2")}
                                        />
                                        <Button
                                            newClass="themeFont"
                                            btnName="Declined"
                                            style={{
                                                borderRadius: "0px 5px 5px 0px",
                                                backgroundColor: status === "Update" ? "#f7dada" : "transparent",
                                                color: status === "3" ? "#b93160" : "#2f2b3db3",
                                                cursor: "pointer",
                                                fontWeight: "500",
                                                opacity: 1,
                                                padding: "10px 20px",
                                                border: "0.5px solid #D8D7DC",
                                                transition: "all 0.3s ease",
                                            }}
                                            onClick={() => setStatus("3")}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end mt-3 mt-md-0">
                                    <div className="px-3 my-1 w-100 d-flex justify-content-center justify-content-md-end">
                                        <DateRangeSelect
                                            startDate={sDate}
                                            endDate={eDate}
                                            onApply={handleDateApply}
                                            onClear={handleDateClear}
                                            placeholder="Select Date"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Table
                            data={data}
                            mapData={mapData}
                            serverPerPage={rowsPerPage}
                            serverPage={page}
                            type={"server"}
                            loading={loadingg}
                            shimmer={true}
                        />

                        <Pagination
                            component="div"
                            count={total}
                            type={"server"}
                            onPageChange={handleChangePage}
                            serverPerPage={rowsPerPage}
                            totalData={total}
                            serverPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                <div className="sellerFooter primeFooter"></div>
            </div>

            <Modal
                open={openReason}
                onClose={handleCloseReason}
                aria-labelledby="decline-modal-title"
                aria-describedby="decline-modal-description"
            >
                <Box sx={style} className="decline-modal">
                    <div className="modal-header">
                        <Typography
                            id="decline-modal-title"
                            variant="h5"
                            component="h2"
                            sx={{
                                fontWeight: 600,
                                color: '#1f2937',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            Decline Request
                        </Typography>
                    </div>

                    <div style={{ padding: "0px 15px" }}>
                        <div className="mb-4">
                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Please provide a reason for declining this request
                            </label>
                            <textarea
                                style={{ width: "100%" }}
                                className="reason-textarea w-full"
                                rows={4}
                                value={reasonData}
                                placeholder="Enter your reason for declining this withdrawal request..."
                                onChange={(e) => {
                                    setReasonData(e.target.value);
                                    if (!e.target.value) {
                                        setError({ ...error, reason: "Reason is required" });
                                    } else {
                                        setError({ ...error, reason: "" });
                                    }
                                }}
                            />
                            {error.reason && (
                                <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <circle cx="12" cy="12" r="10" />
                                        <line x1="12" y1="8" x2="12" y2="12" stroke="white" strokeWidth="2" />
                                        <line x1="12" y1="16" x2="12.01" y2="16" stroke="white" strokeWidth="2" />
                                    </svg>
                                    {error.reason}
                                </p>
                            )}
                        </div>

                        <div className="modal-buttons d-flex justify-content-end">
                            <button
                                onClick={handleCloseReason}
                                className="close-btn"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="submit-btn"
                                style={{ backgroundColor: "#b93160" }}
                            >
                                Decline Request
                            </button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <ImagePreviewModal
                isOpen={showImageModal}
                onClose={() => {
                    setShowImageModal(false);
                    setSelectedImage("");
                }}
                image={selectedImage}
            />

        </div>
    )
}

export default AdminWithdrawal